// removed by extract-text-webpack-plugin
module.exports = {"date-selector-container":"date-selector__date-selector-container__1uaa0","time-wrapper":"date-selector__time-wrapper__2ZDWL"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/CreateEvent/FirstStep/DateModal/DateSelector/date-selector.scss
// module id = 1519
// module chunks = 1